let _showOverlay = $state(false);
let _resolve: ((value: string | PromiseLike<string>) => void) | null = null;
let _stream: MediaStream | null = null;

export const getShowOverlay = () => {
  return _showOverlay;
};

export const startCamera = async (videoElement: HTMLVideoElement) => {
  _stream = await navigator.mediaDevices.getUserMedia({
    video: { facingMode: 'user' },
  });
  videoElement.srcObject = _stream;
  void videoElement.play();
  return _stream;
};

export const stopCamera = () => {
  if (_stream) {
    _stream.getTracks().forEach((track) => track.stop());
    _stream = null;
  }
};

const compressImage = async (base64: string): Promise<string> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const maxWidth = 800;
      const maxHeight = 600;
      let width = img.width;
      let height = img.height;

      if (width > height) {
        if (width > maxWidth) {
          height *= maxWidth / width;
          width = maxWidth;
        }
      } else {
        if (height > maxHeight) {
          width *= maxHeight / height;
          height = maxHeight;
        }
      }

      canvas.width = width;
      canvas.height = height;
      ctx?.drawImage(img, 0, 0, width, height);
      resolve(canvas.toDataURL('image/jpeg', 0.7));
    };
    img.src = base64;
  });
};

export const requestPhotoCapture = () => {
  _showOverlay = true;
  return new Promise<string>((resolve) => {
    _resolve = resolve;
  });
};

export const capturePhoto = async (videoElement: HTMLVideoElement) => {
  const canvas = document.createElement('canvas');
  canvas.width = videoElement.videoWidth;
  canvas.height = videoElement.videoHeight;
  canvas.getContext('2d')?.drawImage(videoElement, 0, 0);

  const compressedImage = await compressImage(canvas.toDataURL('image/jpeg'));
  if (_resolve) {
    _resolve(compressedImage);
    _resolve = null;
  }
  _showOverlay = false;
  stopCamera();
};

export const cancelCapture = () => {
  if (_resolve) {
    _resolve('');
    _resolve = null;
  }
  _showOverlay = false;
  stopCamera();
};
